/** Max URLs per inspect job (aligned with backend `INSPECT_MAX_URLS`). */
export const INSPECT_MAX_URLS_PER_JOB = 2000;
